import IntegrationSystemIcon from './component'

export default IntegrationSystemIcon
